import { cn } from "@/zapi-frontend/shared/lib/utils";
import { chapterIcons, EChapterIcon, defaultChapterIcon } from "@libs/zapi-ui/const";
import { CircularProgress } from "@libs/zapi-ui/custom";

type TChapterIconProps = {
  validQuestionsCount: number;
  totalQuestions: number;
  isActive?: boolean;
  chapterIcon: EChapterIcon | null;
  testId?: string;
  isHidden?: boolean;
  isLoading?: boolean;
  hasNotification?: boolean;
};

export function ChapterIcon(props: TChapterIconProps) {
  const {
    validQuestionsCount,
    totalQuestions,
    isActive = false,
    chapterIcon,
    testId,
    isHidden = false,
    isLoading = false,
    hasNotification = false
  } = props;

  const Icon = chapterIcon ? chapterIcons[chapterIcon] : chapterIcons[defaultChapterIcon];

  return (
    <div
      data-testid={testId}
      className={cn(
        "size-10 min-w-10 rounded-full flex justify-center items-center ml-1 transition-colors duration-300 group-hover:bg-innoveraRed-50",
        isActive && "bg-innoveraRed-50"
      )}
    >
      <div className={`size-8 relative`}>
        {isHidden && <div className="size-[6px] absolute bg-[#A553FD] rounded-full right-0" />}
        {hasNotification && (
          <div className="size-[6px] absolute bg-[#FF603E] rounded-full right-[2px] top-[2px] z-10" />
        )}
        <CircularProgress
          withoutCheckMark
          progress={validQuestionsCount}
          max={totalQuestions}
          size={32}
          strokeWidth={1.5}
          color="var(--innovera-orange400)"
          trackColor={isActive ? "var(--innovera-orange300)" : "var(--innovera-zinc100)"}
          loading={isLoading}
        />

        {Icon && (
          <Icon
            className="size-4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            color={isActive ? "var(--innovera-orange400)" : "var(--innovera-zinc900)"}
          />
        )}
      </div>
    </div>
  );
}
